/* Load Splide CSS */
const splideCSS = document.createElement("link");``
splideCSS.rel = "stylesheet";
splideCSS.href = "https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css";
document.head.appendChild(splideCSS);

/* Load Splide JS */
const splideJS = document.createElement("script");
splideJS.src = "https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js";

splideJS.onload = () => {
    console.log("Splide loaded");

    /* -------------------------------------- */
    /* 1) Encapsular: buscar SOLO nuestro slider */
    /* -------------------------------------- */
    const container = document.querySelector(".splide-vertical-custom #rl-splide");
    if (!container) return; // si no existe, no hace nada

    /* -------------------------------------- */
    /* Responsive height */
    /* -------------------------------------- */
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const sliderHeight = isMobile ? "350px" : "500px";

    /* -------------------------------------- */
    /* SPLIDE instance solo dentro de la clase */
    /* -------------------------------------- */
    const slider = new Splide(container, {
        type: "slide",
        direction: "ttb",
        height: sliderHeight,
        updateOnMove: true,

        perPage: 3,
        focus: 'center',
        trimSpace: false,

        autoHeight: true,
        gap: "1.5rem",

        wheel: false,
        drag: false,

        pagination: false,
        arrows: false,
        speed: 600,
        waitForTransition: false,
    });

    slider.on("mounted move", () => {
        updateDescriptions(slider, container);
    });

    slider.mount();

    /* -------------------------------------- */
    /* Custom arrow buttons — encapsulados    */
    /* -------------------------------------- */
    const prevBtn = container.closest(".splide-vertical-custom").querySelector(".rl-prev");
    const nextBtn = container.closest(".splide-vertical-custom").querySelector(".rl-next");

    prevBtn?.addEventListener("click", () => slider.go("<"));
    nextBtn?.addEventListener("click", () => slider.go(">"));

    /* -------------------------------------- */
    /* Encapsular scroll wheel SOLO en slider */
    /* -------------------------------------- */
    let wheelCooldown = false;

    container.addEventListener('wheel', function(event) {
        event.preventDefault();

        if (Math.abs(event.deltaY) < 40) return;
        if (wheelCooldown) return;

        wheelCooldown = true;

        slider.go(event.deltaY > 0 ? '>' : '<');

        setTimeout(() => wheelCooldown = false, 600);
    }, { passive: false });

    /* -------------------------------------- */
    /* Description Update Function — protected */
    /* -------------------------------------- */
    function updateDescriptions(instance, scope) {

        scope.querySelectorAll(".desc-wrapper").forEach((wrapper) => {
            wrapper.innerHTML = "";
            wrapper.classList.add("empty");
        });

        const activeIndex = instance.index;
        const activeSlide = instance.Components.Slides.getAt(activeIndex).slide;
        const wrapper = activeSlide.querySelector(".desc-wrapper");

        if (!wrapper) return;

        const text = wrapper.dataset.description;
        wrapper.innerHTML = `<p>${text}</p>`;
        wrapper.classList.remove("empty");
    }
};

document.head.appendChild(splideJS);
